import * as React from 'react'

const Twitter = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    aria-label='Twitter logo'
    fill='none'
    height='20'
    role='img'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    stroke='currentColor'
    viewBox='0 0 24 24'
    width='20'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Twitter logo</title>
    <path d='M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z' />
  </svg>
)

export default Twitter



// WEBPACK FOOTER //
// ./src/components/icons/ui/Twitter.tsx